import { render, staticRenderFns } from "./soldOut.vue?vue&type=template&id=480e1716&scoped=true"
import script from "./soldOut.vue?vue&type=script&lang=js"
export * from "./soldOut.vue?vue&type=script&lang=js"
import style0 from "./soldOut.vue?vue&type=style&index=0&id=480e1716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e1716",
  null
  
)

export default component.exports